import {axiosInstance} from "@/http-common";
import CustomStore from "devextreme/data/custom_store";

export async function getForms(): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.get('/api/v1/get/module_form/list')
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}

export async function getForm(hash: string): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.get('/api/v1/get/module_form/' + hash)
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}

export async function getData(userId: number, date: string): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.get('/api/v1/get/module_form/data?userId=' + userId + '&date=' + date)
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}

function isNotEmpty(value) {
    return value !== undefined && value !== null && value !== ''
}
export function getStore() {
    return new CustomStore({
        cacheRawData: false,
        key: 'key',
        load: (loadOptions) => {
            return new Promise((resolve, reject) => {
                let params = '?';
                [
                    'skip',
                    'take',
                    'sort',
                    'filter',
                ].forEach(function (i) {
                    if (i in loadOptions && isNotEmpty(loadOptions[i])) {
                        params += `${i}=${JSON.stringify(loadOptions[i])}&`
                    }
                })
                params = params.slice(0, -1)

                axiosInstance.get(`/api/v1/get/module_form/completed${params}`)
                    .then(response => {
                        resolve({
                            data: response.data.data,
                            totalCount: response.data.totalCount
                        })
                    })
                    .catch(error => reject(error))
            })
        }
    })
}

export async function saveValues(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.post('/api/v1/post/module_form/value', data)
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}

export async function editValues(data: any, params: any): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.patch('/api/v1/patch/module_form/value', data, {params: params})
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}

export async function getRequiredForms(): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.get('/api/v1/get/module_form/required')
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}

export async function deleteData(userId: number, date: string): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.delete('/api/v1/get/module_form/data?userId=' + userId + '&date=' + date)
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}

export async function getCompanyUsers(): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.get('/api/v1/get/module_form/users')
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}

export async function getUserHistory(): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.get('/api/v1/get/module_form/history')
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}

export async function getWorkCard(data): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.post(`/api/v1/get/module_form/report`, data, { responseType: 'blob' })
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}

export async function getExtension(to: string, value: any, options: any | null = null): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.post('/api/v1/get/module_form/extension', {to, value, options})
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}